module.exports = __webpack_public_path__ + "static/img/alllist.336b8e82.png";